import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy } from "@angular/core";
import { Sort } from "@angular/material/sort";
import { Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { OrganizationState } from "@vp/data-access/organization";
import * as UserStateActions from "@vp/data-access/users";
import { UserFilter, UserState, UserStateService } from "@vp/data-access/users";
import { Organization, PageState, User } from "@vp/models";
import { TagSelectorContext } from "@vp/shared/components/tag-selector";
import { PermissionsConstService } from "@vp/shared/permissions-const";
import { BehaviorSubject, Observable, Subject } from "rxjs";

export interface FlattenedUser {
  userId: string;
  userName: string;
  userEmail: string;
  userRoles: string;
  userTags: string;
  active: boolean;
  userLastLoginDate: string;
}

@Component({
  selector: "vp-users-list",
  standalone: false,
  templateUrl: "./users-list.component.html",
  styleUrls: ["./users-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TagSelectorContext, UserStateService]
})
export class UsersListComponent implements OnDestroy {
  organization$: Observable<Organization | null> = inject(Store).select(
    OrganizationState.organization
  );
  currentFilter$: Observable<UserFilter> = inject(Store).select(UserState.currentFilter);
  users$: Observable<User[]> = inject(Store).select(UserState.users);
  pageState$: Observable<Partial<PageState>> = inject(Store).select(UserState.pageState);

  @Input() columnsToDisplay!: string[];
  @Input() users!: FlattenedUser[];
  @Input() isRouterLinkEnabled!: boolean;

  private readonly _destroyed$ = new Subject<void>();
  readonly assignedUsers$ = new BehaviorSubject<FlattenedUser[]>([]);

  constructor(
    public permConst: PermissionsConstService,
    private readonly store: Store,
    private router: Router
  ) {}

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  sortChangeHandler($event: Sort) {
    this.store.dispatch(
      new UserStateActions.SetFilter({
        sort: $event.active,
        sortDirection: $event.direction
      })
    );
  }

  editUser(userId: string) {
    this.router.navigate(["/administration/user", userId], {
      queryParams: { returnUrl: "users" }
    });
  }
}
